import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { trackPage } from '../utils/tracking';

// actions
import { getBeers } from '../actions';

// components
import BeerCard from '../components/beer/card';

const BeerArchive = props => {
  const [beers, setBeers] = useState([]);

  useEffect(() => {
    // fetch beer list
    getBeers().then(res => {
      setBeers(res);
    });

    trackPage();
    window.scrollTo(0, 0);
  }, []);

  return (
    <main id="beer-archive" className="textured">
      <Helmet>
        <title>Our Beer | Baileson</title>
        <meta name="description" content="Man's other best friend" />
      </Helmet>
      <h1 className="heading heading--super orange">The beer</h1>
      <div className="beers">
        {beers &&
          beers.map(beer => {
            const data = {
              id: beer.id,
              slug: beer.slug,
              ...beer.data
            };
            return (
              <div key={beer.id} className="beer">
                <BeerCard beer={data} />
              </div>
            );
          })}
      </div>
    </main>
  );
};

export default BeerArchive;



// WEBPACK FOOTER //
// ./src/containers/BeerArchive.js